import { render, staticRenderFns } from "./SalesOrderForm.vue?vue&type=template&id=36ffa45b"
import script from "./SalesOrderForm.vue?vue&type=script&lang=js"
export * from "./SalesOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports